import React from 'react';
import { css } from 'styled-components';
import { Link, Placeholder } from '@lmn/design-system';
import { useTranslation } from '@/app/components/translations/Translation';
import { useTransportChangeFilters } from '@/app/components/hotel-detail/changeTransport/ChangeTransportFiltersProvider';
import useTransportsFetch from '@/app/components/hotel-detail/travel-api/transportsFetch';

export function ChangeTransportFiltersReset() {
  const { data: travelTransports } = useTransportsFetch();
  const pageConfiguration = (travelTransports as FullAvailableTransportResponse)?.pageConfiguration;

  return (
    <div
      css={css`
        display: flex;
        column-gap: 4px;
        align-items: center;
        flex-wrap: wrap;
        height: fit-content;
        min-width: 228px;
        background-color: ${({ theme }) => theme.commons.colors.gray0};
        border-radius: 8px;
        padding: 20px 16px;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0px;
        font-weight: ${({ theme }) => theme.commons.font.weights.bold};
        line-height: ${({ theme }) => theme.commons.font.heights.medium};
      `}
    >
      {pageConfiguration?.totalProducts ? <ResetFiltersLink /> : <Placeholder height="20px" width="140px" />}
    </div>
  );
}

function ResetFiltersLink() {
  const { clearAll } = useTransportChangeFilters();
  const { t } = useTranslation();

  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <Link variant="accent" onClick={() => clearAll()}>
      {t('vacation.common.filters.results.showall')}
    </Link>
  );
}
